import React, { useState } from "react";
import "./FAQ.css";
import FAQ from "./FAQData";

// Merge translations directly into this file
const translations = {
  en: {
    FAQ_Question1: "Annual Reports to Bolagsverket",
    FAQ_Answer1:
      "You can use the RebelSkool website to prepare and submit Annual Reports according to the K2 regulations for small companies. Try creating and previewing annual reports for free. You only need to pay when you send it to the Swedish Companies Registration Office. Sending an annual report costs only 399 SEK excluding VAT. Of course, you can also buy packages with multiple annual reports to use for other companies or subsequent years.",

    FAQ_Question2: "Need help with your annual report?",
    FAQ_Answer2:
      "If you experience any problems or if something is missing, please contact us by emailing ",
    FAQ_Answer2_Link: "info@rebelskool.com",
    FAQ_Answer2A: " and we will surely be able to help",

    FAQ_Question3: "Data security/GDPR",
    FAQ_Answer3:
      "RebelSkool protects your privacy and your personal data. Read more about the measures we have taken regarding data security and GDPR ",
    FAQ_Answer3_Link: "https://test.rebelskool.com/data-security/",
    FAQ_Answer3_LinkText: "here",

    FAQ_Question4: "Web applications",
    FAQ_Answer4:
      "We at RebelSkool have extensive experience in developing web applications, so do not hesitate to contact us if you are thinking of building web applications, web portals or similar.",

    FAQ_Question5: "Microsoft Business Central",
    FAQ_Answer5:
      "RebelSkool has expert competence in Microsoft Business Central ERP and we have performed complex development of various customizations, reports and integrations. Please contact ",
    FAQ_Answer5_Link: "info@rebelskool.com",
    FAQ_Answer5A:
      " if you need help with Microsoft Business Central development.",
  },
  sw: {
    FAQ_Question1: "Årsredovisningar",
    FAQ_Answer1:
      "Ni kan använda RebelSkools webbsidan att upprätta och lämna Årsredovisningar enligt K2 regelverket för små företag. Prova kostnadsfritt att skapa och förhandsgranska årsredovisningar. Det är först när Ni ska skicka den till Bolagsverket behöver Ni betala. Att skicka en årsredovisning kostar bara 399 kr ex moms. Självklart kan Ni också köpa paket med flera årsredovisningar för att använda för andra bolag eller påföljande år.",

    FAQ_Question2: "Behöver hjälp med årsredovisning?",
    FAQ_Answer2:
      "Om ni upplever något problem eller om det saknas något får ni gärna kontakta oss genom att mejla till ",
    FAQ_Answer2_Link: "info@rebelskool.com",
    FAQ_Answer2A: " så kan vi säkert hjälpa till med det.",

    FAQ_Question3: "Datasäkerhet/GDPR",
    FAQ_Answer3:
      "RebelSkool värnar din integritet och dina personuppgifter. Läs mer om vilka åtgärder vi har tagit kring datasäkerhet och GDPR ",
    FAQ_Answer3_Link: "https://test.rebelskool.com/data-security/",
    FAQ_Answer3_LinkText: "här",

    FAQ_Question4: "Webbapplikationer",
    FAQ_Answer4:
      "Vi på RebelSkool har lång erfarenhet av att utveckla webbapplikationer så tveka inte att kontakta oss om ni funderar på att bygga webbapplikationer, webbportaler eller dylikt.",

    FAQ_Question5: "Affärssystem Microsoft Business Central",
    FAQ_Answer5:
      "RebelSkool har expertkompetens inom affärssystemet Microsoft Business Central och vi har utfört komplex utveckling av olika anpassningar, rapporter samt integrationer. Hör av er till ",
    FAQ_Answer5_Link: "info@rebelskool.com",
    FAQ_Answer5A:
      " om Ni behöver hjälp med Microsoft Business Central utvecklingen.",
  },
};

let userSelectedLanguage = localStorage.getItem("selectedLanguage") || "sw"; // default to 'en' if not set

export default function FAQSection() {
  const [faqs, setFaqs] = useState([
    {
      question: translations[userSelectedLanguage].FAQ_Question1,
      answer: translations[userSelectedLanguage].FAQ_Answer1,
      open: false,
    },
    {
      question: translations[userSelectedLanguage].FAQ_Question2,
      // answer: translations[userSelectedLanguage].FAQ_Answer2,
      answer: (
        <div>
          {translations[userSelectedLanguage].FAQ_Answer2}
          <a
            // href={translations[userSelectedLanguage].FAQ_Answer2_Link}
            href={
              "mailto:" + translations[userSelectedLanguage].FAQ_Answer2_Link
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            {translations[userSelectedLanguage].FAQ_Answer2_Link}
          </a>
          {translations[userSelectedLanguage].FAQ_Answer2A}
        </div>
      ),
      open: false,
    },
    {
      question: translations[userSelectedLanguage].FAQ_Question3,
      answer: (
        <div>
          {translations[userSelectedLanguage].FAQ_Answer3}
          <a
            href={translations[userSelectedLanguage].FAQ_Answer3_Link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {translations[userSelectedLanguage].FAQ_Answer3_LinkText}
          </a>
        </div>
      ),
      open: false,
    },
    {
      question: translations[userSelectedLanguage].FAQ_Question4,
      answer: translations[userSelectedLanguage].FAQ_Answer4,
      open: false,
    },
    {
      question: translations[userSelectedLanguage].FAQ_Question5,
      // answer: translations[userSelectedLanguage].FAQ_Answer5,
      answer: (
        <div>
          {translations[userSelectedLanguage].FAQ_Answer5}
          <a
            // href={translations[userSelectedLanguage].FAQ_Answer2_Link}
            href={
              "mailto:" + translations[userSelectedLanguage].FAQ_Answer5_Link
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            {translations[userSelectedLanguage].FAQ_Answer5_Link}
          </a>
          {translations[userSelectedLanguage].FAQ_Answer5A}
        </div>
      ),
      open: false,
    },
  ]);

  const toggleFAQ = (index) => {
    setFaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }
        return faq;
      })
    );
  };

  return (
    <div className="faq-section">
      <div className="image-class-div">
        <img
          src="https://media.istockphoto.com/id/1398880959/photo/question-mark-symbol-for-faq-information-problem-and-solution-concepts-quiz-test-survey.jpg?b=1&s=612x612&w=0&k=20&c=ZK90ssCj7aOdG1wMpk7oYknV5_V66UWmBxWj6JL7diQ="
          className="image-class"
          alt="FAQ-Questions"
        ></img>
      </div>
      <div className="faqs">
        {faqs.map((faq, index) => (
          <FAQ faq={faq} index={index} key={index} toggleFAQ={toggleFAQ} />
        ))}
      </div>
    </div>
  );
}
